import { Pagination, Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setPagination } from "StoreRedux/Slice/SuscritorSlice";
export default function EventosView({ ...props }) {
    const PAGE_SIZE = 8
    let page = useSelector(state => state.SuscritorSlice.page)
    let usedispatch = useDispatch()
    const handleChange = (event, value) => {
        const inicio = (value - 1) * PAGE_SIZE
        const final = inicio + PAGE_SIZE
        usedispatch(setPagination({ inicio, final, page: value }))
    };
    return (
        <div className=" container-fluid text-end">
            <Box my="2" display="flex" justifyContent="end" >
                {props.eventoslist.length > PAGE_SIZE ?
                    <Pagination 
                        count={Math.ceil(props.eventoslist.length / PAGE_SIZE)}
                        size="large"
                        boundaryCount={5}
                        page={page}
                        onChange={handleChange}
                    /> : ""}
            </Box>
        </div>
    )
}